const accordionTitle = document.querySelectorAll('.accordion__title');

accordionTitle.forEach((title) => {
    title.addEventListener('pointerdown', (e) => {
        let accordions = document.querySelectorAll('.accordion') || [];

        let currentAccordion = title.closest('.accordion');
        let currentAccordionBody = currentAccordion.querySelector('.accordion__body');
        let isAlreadyActive = currentAccordion.classList.contains('active'); // Проверяем, активен ли аккордеон УЖЕ

        // --- Шаг 1: Закрыть ВСЕ аккордеоны ---
        accordions.forEach((accordion) => {
            if (accordion !== currentAccordion) {
                // Закрываем все, кроме той, на которую могли кликнуть
                accordion.classList.remove('active');
                let body = accordion.querySelector('.accordion__body');
                if (!body) return;
                body.style.maxHeight = null; // Убираем max-height
                accordion.querySelector('.accordion__body').style.marginTop = '0';
                accordion.querySelector('.accordion__body').style.marginBottom = '0';
            }
        });

        // --- Шаг 2: Открыть/Закрыть ТЕКУЩИЙ аккордеон ---
        if (!currentAccordion) return;

        if (isAlreadyActive) {
            // Если уже была активна - закрываем ее
            currentAccordion.classList.remove('active');
            if (!currentAccordionBody) return;

            currentAccordionBody.style.maxHeight = null; // Схлопываем контент
            currentAccordionBody.style.marginTop = '0';
            currentAccordionBody.style.marginBottom = '0';
        } else {
            // Если была неактивна - открываем ее
            currentAccordion.classList.add('active');
            // Устанавливаем max-height = высоте контента для плавной анимации
            // currentAccordionBody.scrollHeight < 660
            //     ? (currentAccordionBody.style.overflowY = 'hidden')
            //     : (currentAccordionBody.style.overflowY = 'scroll');

            if(!currentAccordionBody) return;

            currentAccordionBody.style.maxHeight = currentAccordionBody.scrollHeight + 'px';
            // Сбрасываем padding (можно задать конкретные значения, если нужно)
            currentAccordionBody.style.marginTop = '10rem';
            currentAccordionBody.style.marginBottom = '20rem';
        }
    });
});
